// extracted by mini-css-extract-plugin
export default {"image":"App_image__sGTHO"};